import(/* webpackMode: "eager" */ "/opt/build/repo/docs/src/app/(docs)/react/components/navigation-menu/demos/hero/css-modules/index.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/docs/src/app/(docs)/react/components/navigation-menu/demos/nested-inline/css-modules/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/docs/src/app/(docs)/react/components/navigation-menu/demos/nested-inline/tailwind/index.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/docs/src/components/CodeBlock/CodeBlock.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CodeBlockPreComputedContent"] */ "/opt/build/repo/docs/src/components/CodeBlock/CodeBlockPreComputedContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Demo"] */ "/opt/build/repo/docs/src/components/Demo/Demo.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/docs/src/components/Link.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/docs/src/components/HeadingLink.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/docs/src/components/Kbd/Kbd.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/docs/src/components/QuickNav/QuickNav.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ReferenceTable"] */ "/opt/build/repo/docs/src/components/ReferenceTable/ReferenceTable.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MarkdownLink"] */ "/opt/build/repo/docs/src/components/Subtitle/MarkdownLink.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/docs/src/components/Subtitle/Subtitle.css");
;
import(/* webpackMode: "eager", webpackExports: ["Root","Head","Body","Row","RowHeader","ColumnHeader","Cell"] */ "/opt/build/repo/docs/src/components/Table.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TypePropRef"] */ "/opt/build/repo/docs/src/components/TypePropRef/TypePropRef.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TypeRef"] */ "/opt/build/repo/docs/src/components/TypeRef/TypeRef.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/docs/src/css/mdx-components.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/docs/src/app/(docs)/react/components/navigation-menu/demos/nested/css-modules/index.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["TypeCode"] */ "/opt/build/repo/node_modules/.pnpm/@mui+internal-docs-infra@0.11.1-canary.4_@types+react@19.2.14_next@16.1.7_@babel+core@7_e82eb9a44c922c99b1d7c805c79f431f/node_modules/@mui/internal-docs-infra/abstractCreateTypes/TypeCode.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["CodeHighlighterClient"] */ "/opt/build/repo/node_modules/.pnpm/@mui+internal-docs-infra@0.11.1-canary.4_@types+react@19.2.14_next@16.1.7_@babel+core@7_e82eb9a44c922c99b1d7c805c79f431f/node_modules/@mui/internal-docs-infra/CodeHighlighter/CodeHighlighterClient.mjs");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/.pnpm/next@16.1.7_@babel+core@7.29.0_@opentelemetry+api@1.9.0_@playwright+test@1.59.1_babel-p_2d930a055a335bfc6aa590a51974b886/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["NavigationMenuArrow"] */ "/opt/build/repo/packages/react/src/navigation-menu/arrow/NavigationMenuArrow.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NavigationMenuBackdrop"] */ "/opt/build/repo/packages/react/src/navigation-menu/backdrop/NavigationMenuBackdrop.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NavigationMenuContent"] */ "/opt/build/repo/packages/react/src/navigation-menu/content/NavigationMenuContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NavigationMenuIcon"] */ "/opt/build/repo/packages/react/src/navigation-menu/icon/NavigationMenuIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NavigationMenuItem"] */ "/opt/build/repo/packages/react/src/navigation-menu/item/NavigationMenuItem.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NavigationMenuLink"] */ "/opt/build/repo/packages/react/src/navigation-menu/link/NavigationMenuLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NavigationMenuList"] */ "/opt/build/repo/packages/react/src/navigation-menu/list/NavigationMenuList.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NavigationMenuPopup"] */ "/opt/build/repo/packages/react/src/navigation-menu/popup/NavigationMenuPopup.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NavigationMenuPortal"] */ "/opt/build/repo/packages/react/src/navigation-menu/portal/NavigationMenuPortal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NavigationMenuPositioner"] */ "/opt/build/repo/packages/react/src/navigation-menu/positioner/NavigationMenuPositioner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NavigationMenuRoot"] */ "/opt/build/repo/packages/react/src/navigation-menu/root/NavigationMenuRoot.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NavigationMenuTrigger"] */ "/opt/build/repo/packages/react/src/navigation-menu/trigger/NavigationMenuTrigger.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NavigationMenuViewport"] */ "/opt/build/repo/packages/react/src/navigation-menu/viewport/NavigationMenuViewport.tsx");
